export default "__VITE_ASSET__f$adUWhZ__"